(ns pfo.common.event)

(def listeners (atom {}))

(defn set-event-listener
  "Registers listener-fn on js/window, replacing any previous listener with the
   same [handler-id event] key. Component-scoped listeners must be removed with
   remove-event-listener on unmount (#2884)."
  [handler-id event listener-fn]
  (when-let [existing-listener (@listeners [handler-id event])]
    (.removeEventListener js/window (name event) existing-listener))
  (swap! listeners assoc [handler-id event] listener-fn)
  (.addEventListener js/window (name event) listener-fn))

(defn remove-event-listener
  "Removes the window listener registered under [handler-id event], if any."
  [handler-id event]
  (when-let [existing-listener (@listeners [handler-id event])]
    (.removeEventListener js/window (name event) existing-listener)
    (swap! listeners dissoc [handler-id event])))
